import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const SERVICES = {
  ROOT: `${PRIVATE_ROOT}/community/partnered-services`,
  REQUESTED: `${PRIVATE_ROOT}/community/partnered-services/requested`,
}
export const VIEW_SERVICE = `${PRIVATE_ROOT}/community/partnered-services/:id/view`
